import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

export const addLoadingProjectionId = mutatorAction(
    'addLoadingProjectionMutatorId',
    function (itemId: string) {
        const { loadingProjectionIds } = getStore();
        loadingProjectionIds.push(itemId);
    }
);

export const removeLoadingProjectionId = mutatorAction(
    'removeLoadingProjectionMutatorId',
    function (itemId: string) {
        const { loadingProjectionIds } = getStore();
        loadingProjectionIds.remove(itemId);
    }
);
